import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { web3WalletSupportLinks } from '~/data/web3WalletSupportLinks';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplaceGalaWalletStep2',
  props: {
    step: null
  },
  setup(__props: any) {



const { i18n } = useContext();

return { __sfc: true,i18n, web3WalletSupportLinks }
}

})